import { INewbuildingPromo } from '../../types/promosPage';
import { IApplicationState } from '../../types/redux';

export function selectNewbuildingPromos(state: IApplicationState): INewbuildingPromo[] {
  return state.promosPage.newbuildingPromos;
}
